import { Engine, Render, Runner, Bodies, Composite, MouseConstraint, Mouse, Events, Body } from "matter-js";

// create an engine
var engine = Engine.create();
var contactEngine = Engine.create();

// Function to create rectangles for dm-matter-elem elements
function createRectangles(engineToUse, matterElems, elemWhite) {
  return Array.from(matterElems).map(function(matterElem) {
    var elemWidth = matterElem.clientWidth;
    var elemHeight = matterElem.clientHeight;
    var elemPosX = matterElem.offsetLeft + elemWidth / 2;
    var elemPosY = matterElem.offsetTop + elemHeight / 2;
    
    var elemBody = Bodies.rectangle(elemPosX, elemPosY, elemWidth, elemHeight, {
      density: 0.01,
      friction: 0.1,
      restitution: 0.5,
      render: {
        opacity: 0
      }
    });
    
    console.log({ matterElem, elemWidth, elemHeight, elemPosX, elemPosY });
    
    if (matterElem.classList.contains('white')) {
      elemWhite.push(elemBody);
    }
    
    Composite.add(engineToUse.world, elemBody);
    return elemBody;
  });
}

// Function to create circles for dm-matter-elem-circle elements
function createCircles(engineToUse, matterCircle, elemWhite) {
  return Array.from(matterCircle).map(function(matterCircleElem) {
    var circleElemWidth = matterCircleElem.offsetWidth;
    var circleElemHeight = matterCircleElem.offsetHeight;
    var circleElemPosX = matterCircleElem.offsetLeft + circleElemWidth / 2;
    var circleElemPosY = matterCircleElem.offsetTop + circleElemHeight / 2;
    
    var circleBody = Bodies.circle(circleElemPosX, circleElemPosY, Math.max(circleElemWidth, circleElemHeight) / 2, {
      density: 0.01,
      friction: 0.1,
      restitution: 0.5,
      render: {
        opacity: 0
      }
    });
    
    if (matterCircleElem.classList.contains('white')) {
      elemWhite.push(circleBody);
    }
    
    Composite.add(engineToUse.world, circleBody);
    return circleBody;
  });
}

// Function to create pill shapes for dm-matter-elem-pill elements
function createTriangles(engineToUse, matterTriangle, elemWhite) {
  return Array.from(matterTriangle).map(function(matterTriangleElem) {
    var triangleWidth = matterTriangleElem.offsetWidth;
    var triangleHeight = matterTriangleElem.offsetHeight;
    var trianglePosX = matterTriangleElem.offsetLeft + triangleWidth / 2;
    var trianglePosY = matterTriangleElem.offsetTop + triangleHeight / 2;
    
    console.log({ matterTriangleElem, triangleWidth, triangleHeight, trianglePosX, trianglePosY });
    
    var triangleBody = Bodies.fromVertices(
      trianglePosX,
      trianglePosY,
      [
        { x: trianglePosX, y: trianglePosY + triangleHeight },
        { x: trianglePosX + triangleWidth / 2, y: trianglePosY },
        { x: trianglePosX + triangleWidth, y: trianglePosY + triangleHeight }
      ], {
        density: 0.01,
        friction: 0.1,
        restitution: 0.5,
        render: {
          opacity: 0
        }
      }
    );
    
    if (matterTriangleElem.classList.contains('white')) {
      elemWhite.push(triangleBody);
    }
    
    Composite.add(engineToUse.world, triangleBody);
    return triangleBody;
  });
}

// Function to create pill shapes for dm-matter-elem-pill elements
function createHearts(engineToUse, matterHeart, elemWhite) {
  return Array.from(matterHeart).map(function(matterHeartElem) {
    var heartWidth = matterHeartElem.offsetWidth;
    var heartHeight = matterHeartElem.offsetHeight;
    var heartPosX = matterHeartElem.offsetLeft + heartWidth / 2;
    var heartPosY = matterHeartElem.offsetTop + heartHeight / 2;
    
    var heartBody = Bodies.fromVertices(
      heartPosX,
      heartPosY,
      [
        { x: heartPosX - heartWidth / 6, y: heartPosY + 5 * heartHeight / 5 }, // 8
        { x: heartPosX + heartWidth / 2, y: heartPosY + 0 * heartHeight / 5 }, // 3.5
        { x: heartPosX + 7 * heartWidth / 6, y: heartPosY + 5 * heartHeight / 5 } // 9
      ], {
        density: 0.01,
        friction: 0.1,
        restitution: 0.5,
        render: {
          opacity: 0
        },
        rotationSpeed: 0.18,
      }
    );
    
    Composite.add(engineToUse.world, heartBody);
    
    if (matterHeartElem.classList.contains('white')) {
      elemWhite.push(heartBody);
    }
    
    // Body.setCentre(heartBody, {
    //     x: heartPosX + heartWidth / 2,
    //     y: heartPosY + heartHeight / 2
    // });
    // Body.setAngularSpeed(heartBody, Math.random() / 10);
    // Body.setAngularVelocity(heartBody, Math.random() / 10);
    return heartBody;
  });
}

// Function to create pill shapes for dm-matter-elem-pill elements
function createOctogons(engineToUse, matterOcto, elemWhite) {
  return Array.from(matterOcto).map(function(matterOctoElem) {
    var octoWidth = matterOctoElem.offsetWidth;
    var octoHeight = matterOctoElem.offsetHeight;
    var octoPosX = matterOctoElem.offsetLeft + octoWidth / 2;
    var octoPosY = matterOctoElem.offsetTop + octoHeight / 2;
    
    var octoBody1 = Bodies.fromVertices(octoPosX, octoPosY, [
      { x: octoPosX + octoWidth / 4, y: octoPosY },
      { x: octoPosX + octoWidth, y: octoPosY + 3 * octoHeight / 4 },
      { x: octoPosX + 3 * octoWidth / 4, y: octoPosY + octoHeight },
      { x: octoPosX, y: octoPosY + octoHeight / 4 }
    ], {
      density: 0.01,
      friction: 0.1,
      restitution: 0.5,
      render: {
        opacity: 0
      }
    });
    var octoBody2 = Bodies.fromVertices(octoPosX, octoPosY, [
      { x: octoPosX + 3 * octoWidth / 4, y: octoPosY },
      { x: octoPosX + octoWidth, y: octoPosY + octoHeight / 4 },
      { x: octoPosX + octoWidth / 4, y: octoPosY + octoHeight },
      { x: octoPosX, y: octoPosY + 3 * octoHeight / 4 },
    ], {
      density: 0.01,
      friction: 0.1,
      restitution: 0.5,
      render: {
        opacity: 0
      }
    });
    
    const octoBody = Body.create({ parts: [octoBody1, octoBody2], friction: 0.1, restitution: 0.5});
    
    if (matterOctoElem.classList.contains('white')) {
      elemWhite.push(octoBody);
    }
    
    Composite.add(engineToUse.world, octoBody);
    return octoBody;
  });
}

// Function to create static bodies for boundaries
function createBoundaries({ w, h }, engineToUse) {
  
  console.log({ w, h });
  var ground = Bodies.rectangle(w / 2, h, w, 5, {
    isStatic: true,
    render: {
      opacity: 0
    }
  });
  console.log({ ground: { x: w / 2, y: h, width: w, height: 5 } });
  
  var leftWall = Bodies.rectangle(0, h / 3, 5, h * 3, {
    isStatic: true,
    render: {
      opacity: 0
    }
  });
  console.log({ leftWall: { x: 0, y: h / 3, width: 5, height: h * 3 } });
  
  var rightWall = Bodies.rectangle(w, h / 3, 5, h * 3, {
    isStatic: true,
    render: {
      opacity: 0
    }
  });
  console.log({ rightWall: { x: w, y: h / 3, width: 5, height: h * 3 } });
  
  // var topWall = Bodies.rectangle(w / 2, -2 * h, w, 1, {
  //     isStatic: true,
  //     render: {
  //         opacity: 0
  //     }
  // });
  
  // add all of the bodies to the world
  Composite.add(engineToUse.world, [ground, leftWall, rightWall]);
}

document.addEventListener("DOMContentLoaded", function(event){
  // create a renderer
  var matterBox = document.querySelector('.matter-box');
  
  // create a renderer
  var render = Render.create({
    element: matterBox,
    engine: engine,
    options: {
      width: matterBox.clientWidth,
      height: matterBox.clientHeight,
      wireframes: false,
      background: 'transparent'
    }
  });
  
  var matterElems = document.querySelectorAll('.matter-box .animated-elements.square');
  var matterCircle = document.querySelectorAll('.matter-box .animated-elements.circle');
  var matterHeart = document.querySelectorAll('.matter-box .animated-elements.heart');
  var matterTriangle = document.querySelectorAll('.matter-box .animated-elements.triangle');
  var matterOcto = document.querySelectorAll('.matter-box .animated-elements.octo');
  
  const elemWhite = [];
  
  // create bodies for elements
  var elemBodies = createRectangles(engine, matterElems, elemWhite);
  var elemCircles = createCircles(engine, matterCircle, elemWhite);
  var elemTriangles = createTriangles(engine, matterTriangle, elemWhite);
  var elemHearts = createHearts(engine, matterHeart, elemWhite);
  var elemOctos = createOctogons(engine, matterOcto, elemWhite);
  
  const w = matterBox.parentNode.parentNode.clientWidth;
  const h = matterBox.parentNode.parentNode.clientHeight;
  createBoundaries({ w, h }, engine);
  
  function createProjectBlock() {
    const w = matterBox.clientWidth;
    const h = matterBox.clientHeight;
    const bw = 0.7;
    const x1 = (1 - bw) / 2 * w;
    const x2 = (1 - bw) / 2 * w + bw * w;
    
    const block = Bodies.fromVertices(0.5 * matterBox.clientWidth, 2.3 * matterBox.clientHeight, [
      { x: x1, y: 0 }, { x: x1, y: h }, { x: x2, y: h },
      { x: x2, y: 0 }, { x: 0.5 * w, y: -0.8 * h }
    ], {
      isStatic: true,
      restitution: 1,
      friction: 0.5,
      render: {
        opacity: 0
      }
    });
    
    Composite.add(engine.world, block); //, topWall
    
    window.moveProjectBlock = function(direction) {
      let blockX = block.position.x;
      let blockY = block.position.y;
      let destinationY = direction === "up" ? matterBox.clientHeight * 0.3 : matterBox.clientHeight * 2.3;
      function moveStep() {
        if (direction === "down" && blockY < destinationY) {
          $('.animated-elements').removeClass('sides')
          blockY += 50;
          Body.setPosition(block, { x: blockX, y: blockY });
          
          requestAnimationFrame(moveStep);
        } else if (direction === "up" && blockY > destinationY) {
          $('.animated-elements').addClass('sides')
          blockY -= 35;
          Body.setPosition(block, { x: blockX, y: blockY });
          
          requestAnimationFrame(moveStep);
        }
      }
      if (direction === "up") {
        elemWhite.forEach(function(elemBody) {
          console.log("apply force up", { elemBody });
          Body.setPosition( elemBody, { x: elemBody.position.x, y: -elemBody.position.y });   
        });
      }
      requestAnimationFrame(moveStep);
      console.log(`Moving block ${direction}`);
    }
  }
  
  window.applyForce = function(force) {
    elemWhite.forEach(function(elemBody) {
      console.log("apply force up", { elemBody });
      Body.setPosition( elemBody, { x: elemBody.position.x, y: -elemBody.position.y }); 
    });
  };
  
  createProjectBlock();
  
  // create runner
  var runner = Runner.create();
  
  document.addEventListener('logoAnimComplete', function() {
    console.log("Anim complete");
    Runner.run(runner, engine);
  });
  Render.run(render);
  
  // add mouse control
  var mouse = Mouse.create(render.canvas),
  mouseConstraint = MouseConstraint.create(engine, {
    mouse: mouse,
    constraint: {
      stiffness: 0.2,
      render: {
        visible: false
      }
    }
  });
  
  Composite.add(engine.world, mouseConstraint);
  
  // keep the mouse in sync with rendering
  render.mouse = mouse;
  
  // update positions and rotations after every engine update
  Events.on(engine, 'afterUpdate', function() {
    elemBodies.forEach(function(elemBody, index) {
      var angle = elemBody.angle;
      var position = elemBody.position;
      var matterElem = matterElems[index];
      
      matterElem.style.left = (position.x - matterElem.offsetWidth / 2) + 'px';
      matterElem.style.top = (position.y - matterElem.offsetHeight / 2) + 'px';
      matterElem.style.transform = 'rotate(' + angle + 'rad)';
    });
    
    elemCircles.forEach(function(circleBody, index) {
      var angle = circleBody.angle;
      var position = circleBody.position;
      var matterCircleElem = matterCircle[index];
      
      matterCircleElem.style.left = (position.x - matterCircleElem.offsetWidth / 2) + 'px';
      matterCircleElem.style.top = (position.y - matterCircleElem.offsetHeight / 2) + 'px';
      matterCircleElem.style.transform = 'rotate(' + angle + 'rad)';
    });
    
    elemTriangles.forEach(function(triangleBody, index) {
      var angle = triangleBody.angle;
      var position = triangleBody.position;
      var matterTriangleElem = matterTriangle[index];
      
      matterTriangleElem.style.left = (position.x - matterTriangleElem.offsetWidth / 2) + 'px';
      matterTriangleElem.style.top = (position.y - matterTriangleElem.offsetHeight / 3) + 'px';
      matterTriangleElem.style.transform = 'rotate(' + angle + 'rad)';
    });
    
    elemHearts.forEach(function(heartBody, index) {
      var angle = heartBody.angle;
      var position = heartBody.position;
      var matterHeartElem = matterHeart[index];
      
      matterHeartElem.style.left = (position.x - matterHeartElem.offsetWidth / 2) + 'px';
      matterHeartElem.style.top = (position.y - 2 * matterHeartElem.offsetHeight / 3) + 'px';
      matterHeartElem.style.transform = 'rotate(' + angle + 'rad)';
    });
    
    elemOctos.forEach(function(octoBody, index) {
      var angle = octoBody.angle;
      var position = octoBody.position;
      var matterOctoElem = matterOcto[index];
      
      matterOctoElem.style.left = (position.x - matterOctoElem.offsetWidth / 2) + 'px';
      matterOctoElem.style.top = (position.y - matterOctoElem.offsetHeight / 2) + 'px';
      matterOctoElem.style.transform = 'rotate(' + angle + 'rad)';
    });
  });
  
  // Function to handle resize event
  function handleResize() {
    // Clear the existing bodies
    Composite.clear(engine.world, false);
    
    // Recreate boundaries and bodies
    createBoundaries({ w, h }, engine);
    elemBodies = createRectangles(engine, matterElems, elemWhite);
    elemCircles = createCircles(engine, matterCircle, elemWhite);
    elemTriangles = createTriangles(engine, matterTriangles, elemWhite);
    elemOctos = createOctogons(engine, matterOcto, elemWhite);
    // Update the renderer size
    render.options.width = w;
    render.options.height = h;
    
    // Update mouse constraint
    mouseConstraint.mouse.element.removeEventListener("mousewheel", mouseConstraint.mouse.mousewheel);
    mouseConstraint.mouse.element.removeEventListener("DOMMouseScroll", mouseConstraint.mouse.mousewheel);
    
    mouseConstraint.mouse.element.removeEventListener('touchstart', mouseConstraint.mouse.mousedown);
    mouseConstraint.mouse.element.removeEventListener('touchmove', mouseConstraint.mouse.mousemove);
    mouseConstraint.mouse.element.removeEventListener('touchend', mouseConstraint.mouse.mouseup);
    
    mouseConstraint.mouse.element.addEventListener('touchstart', mouseConstraint.mouse.mousedown, { passive: true });
    mouseConstraint.mouse.element.addEventListener('touchmove', (e) => {
      if (mouseConstraint.body) {
        mouseConstraint.mouse.mousemove(e);
      }
    });
    mouseConstraint.mouse.element.addEventListener('touchend', (e) => {
      if (mouseConstraint.body) {
        mouseConstraint.mouse.mouseup(e);
      }
    });
  }
  
  // Add resize event listener
  window.addEventListener('resize', handleResize);
  
  // Allow scrolling when mouse is on matter container
  // mouseConstraint.mouse.element.removeEventListener("mousewheel", mouseConstraint.mouse.mousewheel);
  // mouseConstraint.mouse.element.removeEventListener("DOMMouseScroll", mouseConstraint.mouse.mousewheel);
  
  // Allow swiping on touch-screen when in touch with the matter container
  mouseConstraint.mouse.element.removeEventListener('touchstart', mouseConstraint.mouse.mousedown);
  mouseConstraint.mouse.element.removeEventListener('touchmove', mouseConstraint.mouse.mousemove);
  mouseConstraint.mouse.element.removeEventListener('touchend', mouseConstraint.mouse.mouseup);
  
  mouseConstraint.mouse.element.addEventListener('touchstart', mouseConstraint.mouse.mousedown, { passive: true });
  mouseConstraint.mouse.element.addEventListener('touchmove', (e) => {
    if (mouseConstraint.body) {
      mouseConstraint.mouse.mousemove(e);
    }
  });
  mouseConstraint.mouse.element.addEventListener('touchend', (e) => {
    if (mouseConstraint.body) {
      mouseConstraint.mouse.mouseup(e);
    }
  });
});